import { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { EditAddressSingleOrder } from '../../../redux/user/user_order/user_order_services_sync';
import { InfinitySpin } from 'react-loader-spinner';

const baseSchema = Yup.object({
  phone_number: Yup.string().required(),
  address_one: Yup.string().required(),
  address_two: Yup.string(),
});

export default function CustomModal({ isOpen, onClose }) {
  const dispatch = useDispatch();

  const { current_room } = useSelector((state) => state.room);

  const { order_edit_address_single_loader } = useSelector(
    (state) => state.user_order
  );

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (order_edit_address_single_loader) return;

    const payload = {
      ...value,
    };

    await dispatch(
      EditAddressSingleOrder({
        ...payload,
        orderId: current_room.split('-')[0],
      })
    );

    resetForm();

    onClose();
  };

  // Close modal when Escape key is pressed
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: '',
      slug: '',
      description: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  return (
    <div>
      {/* Modal Backdrop */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4 md:p-6 overflow-y-auto">
          {/* Modal Content */}
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-md relative animate-fadeIn my-4"
            style={{ animation: 'fadeIn 0.3s ease-out' }}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 focus:outline-none p-1 rounded-full hover:bg-gray-100"
              aria-label="Close"
            >
              <FaTimes className=" w-5 h-5" />
            </button>

            {/* Modal Header */}
            <div className="p-4 sm:p-6 border-b border-gray-200">
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                Contact Information
              </h2>
              <p className="mt-1 text-xs sm:text-sm text-gray-500">
                Please provide your contact details below.
              </p>
            </div>

            {/* Modal Body */}
            <form onSubmit={handleSubmit}>
              <div className="p-4 sm:p-6 space-y-3 sm:space-y-4">
                {/* <div className="space-y-1 sm:space-y-2">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                    className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div> */}

                <div className="space-y-1 sm:space-y-2">
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Phone Number
                  </label>
                  <input
                    id="phone"
                    name="phone_number"
                    type="tel"
                    value={values.phone_number}
                    onChange={handleChange}
                    placeholder="(123) 456-7890"
                    required
                    className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    style={{
                      border: errors.name && '1px solid red',
                    }}
                  />
                </div>

                <div className="space-y-1 sm:space-y-2">
                  <label
                    htmlFor="address1"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Address Line 1
                  </label>
                  <input
                    id="address1"
                    name="address_one"
                    value={values.address_one}
                    onChange={handleChange}
                    placeholder="Street address"
                    required
                    className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    style={{
                      border: errors.name && '1px solid red',
                    }}
                  />
                </div>

                <div className="space-y-1 sm:space-y-2">
                  <label
                    htmlFor="address2"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Address Line 2
                  </label>
                  <input
                    id="address2"
                    name="address_two"
                    value={values.address_two}
                    onChange={handleChange}
                    placeholder="Apt, suite, etc. (optional)"
                    className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    style={{
                      border: errors.name && '1px solid red',
                    }}
                  />
                </div>
              </div>

              {/* Modal Footer */}
              <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200 rounded-b-lg flex justify-end">
                <button
                  type="button"
                  className="px-3 sm:px-4 py-1.5 sm:py-2 text-sm sm:text-base bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                  onClick={handleSubmit}
                >
                  {order_edit_address_single_loader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="70" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
